import React from 'react';
import RelationshipBreadcrumbs from "../view/RelationshipBreadcrumbs.js";
function create(molten, relationship, {
  actionPath,
  t
}) {
  // Get parameters
  const {
    path
  } = relationship;
  return {
    id: `route.${path}.ResourceTemporaryUsers:breadcrumbs`,
    matches: {
      client: 'Breadcrumbs'
    },
    exact: true,
    path: actionPath,
    render: ({
      match,
      ...rest
    }) => {
      const rel = relationship.createItem(match);
      const name = t('name');
      const extraCrumbs = [{
        name,
        tooltip: name,
        url: actionPath
      }];
      return /*#__PURE__*/React.createElement(RelationshipBreadcrumbs, {
        match,
        ...rest,
        extraCrumbs,
        relationship: rel
      });
    }
  };
}
export default {
  create
};